import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { User } from 'src/app/model/user';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ClienteapiService } from 'src/app/dao/api_cliente.service';
import { GlobalService } from 'src/app/dao/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  constructor(private menu: MenuController,
              private router: Router,
              private toast: ToastService,
              private apicliente: ClienteapiService,
              public global: GlobalService) { }

  isTextFieldType: boolean;
  usuarioLogado: User;
  usuarioForm: string;
  senhaForm: string;
  versao: any;


   ngOnInit() {
     this.validar_setup();
     this.usuarioLogado = new User();
  }

   ionViewDidEnter() {
    this.validar_setup();
    this.menu.enable(false);
  }

  ionViewWillLeave() {
    this.menu.enable(true);
  }


  togglePasswordFieldType() {
    this.isTextFieldType = !this.isTextFieldType;
  }

  async validar_setup() {

  }

   delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  esqueceuSenha(){
    this.router.navigate(['/esqueceu-senha']);
  }



  async criaSession() {
    try {
        this.apicliente.verificaLoginWeb(this.usuarioForm, this.senhaForm).then(res => {

        // Criar o token basic
      const credentials = `${this.usuarioForm}:${this.senhaForm}`;
      const base64Credentials = btoa(credentials); 
      const basicToken = `Basic ${base64Credentials}`;
      localStorage.setItem('authToken', basicToken);  // localStorage

        //this.toast.showSucess('Sucesso!');
        let user = this.usuarioForm;
        let pass = this.senhaForm;
        let nome = res[0].nome;
        let plano = res[0].plano;
        let impressao_tamanho = "";
        if(res[0].impressao_tamanho === "1" || res[0].impressao_tamanho === 1){
           impressao_tamanho = "1";
        }else{
           impressao_tamanho = "0";
        }
        
        let impressao_tipo = res[0].impressao_tipo;
        console.log(res[0]);
        console.log(res[0].impressao_tamanho);
        console.log(res[0].impressao_tipo);
        let comandaMesa = "";
        if(res[0].label_comanda_mesa === "1" || res[0].label_comanda_mesa === 1){
         comandaMesa = 'Comanda';
        } else {
         comandaMesa = 'Mesa';
        }


        console.log(res[0]);
        let labelEncomenda = "";
        if(res[0].label_encomenda === "1" || res[0].label_encomenda === 1){
         labelEncomenda = 'Agendamento';
        } else {
         labelEncomenda = 'Encomenda';
        }


        localStorage.setItem('user', this.usuarioForm);
        localStorage.setItem('pass', this.senhaForm);
        localStorage.setItem('nome', res[0].nome);
        localStorage.setItem('plano', res[0].plano)
        localStorage.setItem('impressao_tamanho', impressao_tamanho);
        localStorage.setItem('impressao_tipo', res[0].impressao_tipo);
        localStorage.setItem('comandaMesa', comandaMesa);
        localStorage.setItem('labelEncomenda', labelEncomenda);

        this.router.navigate(['/home']);
      }).catch(async err => {
        console.log('err', err);
        this.toast.showError('Usuário ou senha incorretos');
      });


    } catch (error) {
      this.toast.showError('Ocorreu um erro');
    }

  }


  async criaSessionFake() {
    try {

  this.router.navigate(['/inicio']);
      } catch (error) {
      console.log(error);
      this.toast.showError('Ocorreu um erro');
    }

  }


  verificaLogin() {

  }


}


